
@if (showLocalFilter) {
  <mat-form-field class="search-input">
    <input placeholder="Filter"
      matInput
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="applyFilter($event)">
      <mat-chip-grid #chipList>
      </mat-chip-grid>
    </mat-form-field>
  }
  @for (item of searchItems; track item) {
    <mat-chip-option [selectable]="selectable"
      [removable]="removable" (removed)="remove(item)">
      {{item.name}}
      @if (removable) {
        <mat-icon matChipRemove>cancel</mat-icon>
      }
    </mat-chip-option>
  }
  <div class="example-container">
    <table mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      matSort
      class="mat-elevation-z8 mat-table-custom" id="otherassetlist">
      @for (item of columnsToDisplay; track item) {
        <ng-container matColumnDef="{{item}}">
          <th mat-header-cell *matHeaderCellDef>
            {{item === 'actions' || item === 'status' || item === 'index' || item === 'arrow-details' || item === 'arrow-attr' ? '' : item}}
          </th>
          @if (item==='arrow-attr') {
            <td mat-cell *matCellDef="let element"
              (click)="pushPopElement(element, true)">
              @if (checkExpanded(element, true)) {
                <span class="material-icons" matTooltip="Collapse">
                  expand_less
                </span>
              } @else {
                <span class="material-icons" matTooltip="Attributes">
                  build
                </span>
              }
            </td>
          }
          @if (item==='arrow-details') {
            <td mat-cell *matCellDef="let element"
              (click)="pushPopElement(element, false)">
              @if (checkExpanded(element, false)) {
                <span class="material-icons" matTooltip="Collapse">
                  expand_less
                </span>
              } @else {
                <span class="material-icons" matTooltip="More Details">
                  expand_more
                </span>
              }
            </td>
          }
          @if (item === 'index') {
            <td mat-cell *matCellDef="let element; let i = dataIndex">
              <p>{{i+1}}</p>
            </td>
          }
          @if (item==='actions') {
            <td mat-cell *matCellDef="let element">
              @if (!isEditing(element, null,null, false)) {
                <button mat-icon-button matTooltip="Edit Row"
                  (click)="onRowEditInit(element, null, false)">
                  <mat-icon>edit</mat-icon>
                </button>
              }
              @if (!isEditing(element, null,null, false)) {
                <button mat-icon-button matTooltip="Check History"
                  (click)="openChangeHistoryDialog(element)">
                  <mat-icon>history_toggle_off</mat-icon>
                </button>
              }
              @if (isEditing(element, null,null, false)) {
                <button mat-icon-button matTooltip="Cancel Row"
                  (click)="onRowEditCancel(element, null, false)">
                  <mat-icon>rotate_left</mat-icon>
                </button>
              }
            </td>
          }
          @if (item!=='actions') {
            <ng-container *matCellDef="let element">
              @switch (getDataType(item)) {
                @case ('boolean') {
                  <td mat-cell>
                      <mat-checkbox (change)="changeElement(element, item, $event.checked)" [checked]="getInput(element,item)" [ngClass]="isEditing(element, null,item, false) ? 'black' :''" [disabled]="!isEditing(element, null,item, false)"></mat-checkbox>
                    </td>
                }
                @case ('string') {
                  <td mat-cell>
                    @if (!isEditing(element, null,item, false)) {
                      <p [innerHTML]="getInput(element,item)"></p>
                    }
                    @if (isEditing(element, null,item, false)) {
                      <mat-form-field floatLabel="auto">
                        <input matInput [value]="element[item]" [(ngModel)]="element[item]">
                      </mat-form-field>
                    }
                  </td>
                }
                @case ('number') {
                  <td mat-cell>
                    @if (!isEditing(element, null,item, false)) {
                      <p [innerHTML]="getInput(element,item)"></p>
                    }
                    @if (isEditing(element, null,item, false)) {
                      <mat-form-field floatLabel="auto">
                        <input matInput type="number" [value]="element[item]" [(ngModel)]="element[item]">
                      </mat-form-field>
                    }
                  </td>
                }
                @case ('date') {
                  <td mat-cell class="datepicker">
                    @if (!isEditing(element, null,item, false)) {
                      <p [innerHTML]="getInput(element,item) | date:'yyyy-MM-dd HH:mm'"></p>
                    }
                    @if (isEditing(element, null,item, false)) {
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker"
                          [(ngModel)]="element[item]"
                          (dateChange)= "getDateUTCChange($event, element, item)">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      }
                    </td>
                  }
                }
              </ng-container>
            }
          </ng-container>
        }

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="subcolumnsDetailsToDisplay.length">
            @if (element.Details) {
              <div [@detailExpand]="checkExpanded(element, false) ? 'expanded' : 'collapsed'"
                [class.expandedDetail]="checkExpanded(element, false)">
                <table mat-table [dataSource]="element.Details" class="mat-subtable-custom" id="otherassetdetails">
                  @for (item of subcolumnsDetailsToDisplay; track item) {
                    <ng-container matColumnDef="{{item}}">
                      <th mat-header-cell *matHeaderCellDef>
                        {{item === 'actions' ? '' : item}}
                      </th>
                      <ng-container *matCellDef="let subelement">
                        @switch (getDataType(item)) {
                          @case ('boolean') {
                            <td mat-cell>
                                <mat-checkbox (change)="changeElement(subelement, item, $event.checked)" [checked]="getInput(subelement,item)" [ngClass]="isEditing(element, null,item, false) ? 'black' :''" [disabled]="!isEditing(element, null,item, false)"></mat-checkbox>
                              </td>
                          }
                          @case ('string') {
                            <td mat-cell>
                              @if (!isEditing(element, null,item, false)) {
                                <p [innerHTML]="getInput(subelement,item)"></p>
                              }
                              @if (isEditing(element, null,item, false)) {
                                <mat-form-field floatLabel="auto">
                                  <input matInput [value]="subelement[item]" [(ngModel)]="subelement[item]">
                                </mat-form-field>
                              }
                            </td>
                          }
                          @case ('number') {
                            <td mat-cell>
                              @if (!isEditing(element, null,item, false)) {
                                <p [innerHTML]="getInput(subelement,item)"></p>
                              }
                              @if (isEditing(element, null,item, false)) {
                                <mat-form-field floatLabel="auto">
                                  <input matInput type="number" step="1" min="0" [value]="subelement[item]" [(ngModel)]="subelement[item]">
                                </mat-form-field>
                              }
                            </td>
                          }
                          @case ('date') {
                            <td mat-cell class="datepicker">
                              @if (!isEditing(element, null,item, false)) {
                                <p [innerHTML]="getInput(subelement,item) | date:'yyyy-MM-dd HH:mm'"></p>
                              }
                              @if (isEditing(element, null,item, false)) {
                                <mat-form-field>
                                  <input matInput [matDatepicker]="picker"
                                    [(ngModel)]="subelement[item]"
                                    (dateChange)= "getDateUTCChange($event, subelement, item)">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                  </mat-form-field>
                                }
                              </td>
                            }
                          }
                        </ng-container>
                      </ng-container>
                    }
                    <tr mat-header-row class="subtableheader" *matHeaderRowDef="subcolumnsDetailsToDisplay"></tr>
                    <tr mat-row *matRowDef="let i2 = index; columns: subcolumnsDetailsToDisplay;"
                      [class.alternative2]="isEditing(element, null, null, false)"
                    class="subitem"></tr>
                  </table>
                </div>
              }
            </td>
          </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail2">
            <td mat-cell *matCellDef="let element" [attr.colspan]="subcolumnsDetailsToDisplay.length">
              @if (element.Attrs) {
                <div [@detailExpand]="checkExpanded(element,true) ? 'expanded' : 'collapsed'"
                  [class.expandedDetail]="checkExpanded(element,true)">
                  <table mat-table [dataSource]="element.Attrs" class="mat-subtable-custom" id="otherassetattrs">
                    @for (item of subcolumnsattrToDisplay; track item) {
                      <ng-container matColumnDef="{{item}}">
                        <th mat-header-cell *matHeaderCellDef>
                          {{item === 'actions' ? '' : item}}
                        </th>
                        @if (item==='actions') {
                          <td mat-cell *matCellDef="let subelement">
                            @if (!isEditing(element, subelement, item, true)) {
                              <button mat-icon-button matTooltip="Edit Row"
                                (click)="onRowEditInit(element, subelement, true)">
                                <mat-icon>edit</mat-icon>
                              </button>
                            }
                            @if (isEditing(element, subelement, item, true)) {
                              <button mat-icon-button matTooltip="Cancel Row"
                                (click)="onRowEditCancel(element, subelement, true)">
                                <mat-icon>rotate_left</mat-icon>
                              </button>
                            }
                          </td>
                        }
                        @if (item!=='actions') {
                          <ng-container *matCellDef="let subelement">
                            @switch (getDataType(item)) {
                              @case ('boolean') {
                                <td mat-cell>
                                    <mat-checkbox (change)="changeElement(subelement, item, $event.checked)" [checked]="getInput(subelement,item)" [ngClass]="isEditing(element, subelement, item, true) ? 'black' :''"
                                    [disabled]="!isEditing(element, subelement, item, true) "></mat-checkbox>
                                  </td>
                              }
                              @case ('string') {
                                <td mat-cell>
                                  @if (!isEditing(element, subelement, item, true)) {
                                    <p [innerHTML]="getInput(subelement,item)"></p>
                                  }
                                  @if (isEditing(element, subelement, item, true) ) {
                                    <mat-form-field floatLabel="auto">
                                      <input matInput [value]="subelement[item]" [(ngModel)]="subelement[item]">
                                    </mat-form-field>
                                  }
                                </td>
                              }
                              @case ('number') {
                                <td mat-cell>
                                  @if (!isEditing(element, subelement, item, true) ) {
                                    <p [innerHTML]="getInput(subelement,item)"></p>
                                  }
                                  @if (isEditing(element, subelement, item, true) ) {
                                    <mat-form-field floatLabel="auto">
                                      <input matInput type="number" step="0.01" min="0" [value]="subelement[item]" [(ngModel)]="subelement[item]">
                                    </mat-form-field>
                                  }
                                </td>
                              }
                              @case ('date') {
                                <td mat-cell class="datepicker">
                                  @if (!isEditing(element, subelement, item, true) ) {
                                    <p [innerHTML]="getInput(subelement,item) | date:'yyyy-MM-dd HH:mm'"></p>
                                  }
                                  @if (isEditing(element, subelement, item, true) ) {
                                    <mat-form-field>
                                      <input matInput [matDatepicker]="picker" [(ngModel)]="subelement[item]">
                                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                      <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                  }
                                </td>
                              }
                              @default {
                                <td mat-cell></td>
                              }
                            }
                          </ng-container>
                        }
                      </ng-container>
                    }
                    <tr mat-header-row class="subtableheader" *matHeaderRowDef="subcolumnsattrToDisplay"></tr>
                    <tr mat-row *matRowDef="let i2 = index; columns: subcolumnsattrToDisplay; let subelement;"
                      [class.alternative2]="isEditing(element, subelement, null, true)"
                    class="subitem"></tr>
                  </table>
                </div>
              }
            </td>
          </ng-container>
          <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
          <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"
            class="item"
            [class.alternative2]="isEditing(element, null,null, false)">
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="row-subitem"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail2']" class="row-subitem"></tr>
          </table>
        </div>



